export default from './Notification';



// WEBPACK FOOTER //
// ./src/components/organismes/Notification/index.js